/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { RequestPasswordReset } from './forgot.model';

export enum ActionTypes {
  REQUEST_RESET = '[Auth] Request Reset',
  REQUEST_RESET_SUCCESS = '[Auth] Request Reset Success',
  REQUEST_RESET_FAILURE = '[Auth] Request Reset Failure',
}

export class RequestReset implements Action {
  public readonly type = ActionTypes.REQUEST_RESET;

  constructor(public payload: RequestPasswordReset) {}
}

export class RequestResetSuccess implements Action {
  public readonly type = ActionTypes.REQUEST_RESET_SUCCESS;
}

export class RequestResetFailure implements Action {
  public readonly type = ActionTypes.REQUEST_RESET_FAILURE;

  constructor(public payload: string) {}
}

export type Actions = RequestReset | RequestResetSuccess | RequestResetFailure;
